import Vue from 'vue'
import Router from 'vue-router'
import CoreLib from '@/lib/common'
/* 通用界面 */
import xhorseIm from '@/components/zh-cn/xhorseIm/index.vue'
import software from '@/components/zh-cn/software/index.vue'
import download from '@/components/zh-cn/download/index.vue'
import xhorseImMobile from '@/components/mobile/zh-cn/xhorseIm/index.vue'
import softwareMobile from '@/components/mobile/zh-cn/software/index.vue'
import downloadMobile from '@/components/mobile/zh-cn/download/index.vue'


/* PC端主界面 */
import index from '@/components/zh-cn/index'
import about from '@/components/zh-cn/about'
import join from '@/components/zh-cn/join'
import apply from '@/components/zh-cn/apply'
import news from '@/components/zh-cn/news'
import support from '@/components/zh-cn/support'
import solution from '@/components/zh-cn/solution'

/*移动端主界面*/
import indexMobile from '@/components/mobile/zh-cn/index'
import aboutMobile from '@/components/mobile/zh-cn/about'
import solutionMobile from '@/components/mobile/zh-cn/solution'
import newsMobile from '@/components/mobile/zh-cn/news'
import joinMobile from '@/components/mobile/zh-cn/join'
import applyMobile from '@/components/mobile/zh-cn/apply'
import supportMobile from '@/components/mobile/zh-cn/support'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

const navigatorObject = require('@/lib/common');
const commonMethods = navigatorObject.default;
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? indexMobile : index,
            alias: '/index'
        },
        {
            path: '/about',
            name: 'about',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? aboutMobile : about,
        },
        {
            path: '/join',
            name: 'join',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? joinMobile : join
        },
        {
            path: '/apply',
            name: 'apply',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? applyMobile : apply,
        },
        {
            path: '/news',
            name: 'news',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? newsMobile : news,
        },
        {
            path: '/support',
            name: 'support',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? supportMobile : support,
        },
        {
            path: '/solution',
            name: 'solution',
            component: CoreLib._isMobile() && !CoreLib._isPc() ? solutionMobile : solution,
        },
        {
            path: '/software',
            name: 'software',
            component:CoreLib._isMobile() && !CoreLib._isPc() ?  softwareMobile: software  ,
        },
        {
            path: '/xhorseIM',
            name: 'xhorseIM',
            component:CoreLib._isMobile() && !CoreLib._isPc() ? xhorseImMobile : xhorseIm ,
        },
        {
            path: '/download',
            name: 'download',
            component:CoreLib._isMobile() && !CoreLib._isPc() ? downloadMobile : download ,
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
    
});


router.beforeEach(function (to, from, next) {
    const path = $.trim(to.path);
    const component = path.split("/");
    
    if (component.length >= 2) {
        Vue.prototype.$path = component[0] == "" ? "zh-cn" : "en-us";
        Vue.prototype.$name = component[1];
    } else {
        Vue.prototype.$path = 'zh-cn';
        Vue.prototype.$name = 'index';
    }
    
    if (commonMethods._isMobile() && !commonMethods._isPc()) {
        document.body.style.position = '';
        document.body.style.top = '';
    }
    next(true)
    
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js